import { useEffect, useState } from "react";

const getFragment = () => {
  return window.location.hash.substring(1);
};

/**
 * @returns {String} URL fragment
 */
const useUrlFragment = () => {
  const [fragment, setFragment] = useState(getFragment);

  useEffect(() => {
    const onChange = () => {
      setFragment(getFragment());
    };
    window.addEventListener("hashchange", onChange);
    return () => {
      window.removeEventListener("hashchange", onChange);
    };
  }, []);

  return fragment;
};

export default useUrlFragment;
